import { Fragment } from 'react';
import { AVAILABLE, COLLECTED, COMPLETED } from '../../../../../constants/components/pages/challenges/statuses';
import { safeHTML } from '../../../../../utils/safeHTML';
import { image } from '../../../../../utils/data/baseUrl';
import { useChallengeSubQuests } from '../../model/hooks/useChallengeSubQuests';
import TaskItem from '../../../task/TaskItem/TaskItem';
import { useAccountMode } from '../../../../../hooks/useAccountMode';
import { useContent } from '../../../../../redux/reducer/content';
import { useTranslation } from '../../../../../translations';
import classNames from 'classnames';

export default function ChallengeSectionBody({ status, challengeData, isVisibleBody }) {
  const { quests } = useContent();
  const { mode: accountMode } = useAccountMode();
  const { subQuests } = challengeData;
  const { t } = useTranslation();
  const formattedSubQuests = useChallengeSubQuests(subQuests);

  return {
    [AVAILABLE]() {
      return (
        <div
          className={classNames('challenges__section-body', { 'challenges__section-body_open': isVisibleBody })}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={'challenges__section-body-wrapper'}>
            <div className={'challenges__section-body-list'}>
              {formattedSubQuests.map((subQuest, index) => (
                <Fragment key={subQuest.id}>
                  {subQuest.isLocked && (
                    <div className={`challenges__section-sep`}>{safeHTML(t('challenges.lockNote'))}</div>
                  )}

                  <TaskItem
                    className={classNames('task__item_challenge challenge__item', {
                      ['challenges__item_lock']: subQuest.isLocked,
                    })}
                    {...subQuest}
                    accountMode={accountMode}
                    index={index}
                    quests={quests}
                    quest={subQuest}
                  >
                    {subQuest.isLocked && (
                      <img src={image('challenges/lock.svg')} className={'challenges__item-lock'} />
                    )}
                  </TaskItem>
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      );
    },
    [COMPLETED]() {
      return <img src={image('challenges/done-b.svg')} className={'challenges__section-done'} />;
    },
    [COLLECTED]() {
      return <img src={image('challenges/done-b.svg')} className={'challenges__section-done'} />;
    },
  }[status]?.();
}
